// H2.8 — cliente HTTP v2: Authorization Bearer + refresh automático.
// withCredentials manda la cookie httpOnly `rt` al backend (CORS con
// allowlist + credentials del lado servidor).
import axios from 'axios';
import { authStore } from './authStore';

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 30_000,
  withCredentials: true,
});

http.interceptors.request.use((config) => {
  const token = authStore.getToken();
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

// Refresh único compartido: si N requests reciben 401 a la vez, solo se hace
// UNA llamada a /auth/refresh y las demás la esperan.
let refreshing = null;

async function refreshSession() {
  if (!refreshing) {
    refreshing = axios
      .post(`${import.meta.env.VITE_API_URL}/api/g/v2/auth/refresh`, null, {
        withCredentials: true,
      })
      .then((r) => {
        authStore.setSession(r.data);
        return r.data.access_token;
      })
      .finally(() => {
        refreshing = null;
      });
  }
  return refreshing;
}

http.interceptors.response.use(
  (r) => r,
  async (err) => {
    const original = err.config || {};
    const esAuthEndpoint = String(original.url || '').includes('/api/g/v2/auth/');
    if (err.response?.status === 401 && !original._retried && !esAuthEndpoint) {
      original._retried = true;
      try {
        const token = await refreshSession();
        original.headers = { ...original.headers, Authorization: `Bearer ${token}` };
        return http(original);
      } catch {
        authStore.clear();
        window.dispatchEvent(new CustomEvent('auth:logout'));
      }
    }
    return Promise.reject(err);
  }
);
